document.addEventListener("DOMContentLoaded", function() {
    const labels = document.querySelectorAll('select.single-option-selector');

    labels.forEach(label => {
        label.addEventListener('click', function() {
            const productForm = document.querySelector('[bss-b2b-product-form="main"]');

            setTimeout(() => {
                BSS_B2B?.observer?.productSubject?.notifyObserver?.(
                'VariantChange',
                'VariantSelectChange',
                { productForm }
            );
            }, 1000);
        });
    });
});

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class" &&
          mutation.target.classList.contains("samitaWS-cart-form") ||
          mutation.target.classList.contains("active")
        ) {
          console.log("open mini cart");
          handleCpOnCartDrawer();
        }
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
      subtree: true
    });
  }, 300);
}

const handleCpOnCartDrawer = () => {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      console.log("data", data);

    //   const nodes = document.querySelectorAll(".fl.f-aic.cart-item");
    const nodes = document.querySelectorAll(".mini_pr_list .fl.f-aic");

      nodes.forEach((node, i) => {
        const item = data.items[i];
        if (!item) return;

        const moneyNode = node.querySelector("span[bss-b2b-cart-item-key]");
        if (moneyNode) {
          moneyNode.setAttribute("bss-b2b-cart-item-key", item.key);
          BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
        }
      });
    });
};
